export default __webpack_public_path__ + "images/loading_image_[fullhash:7].gif";